import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from "react";
import { IconPlusCircleOutline, IconMinusCircleOutline } from "@sfx/icons";
import cx from 'classnames';
import { FormGroup, Label, Col, Row } from "reactstrap";
import { cloneDeep } from "lodash";
import Select from "../../../../../Basic/Select";
import SubscriptionOption, { SubscriptionValue } from "../../../common/subscriptionOption.component";
import useSolutions, { getKeyUserTypeSubscriptions } from '../../hooks/useSolutions';

var checkHasUserTypeSubscription = function checkHasUserTypeSubscription(targetSolution) {
  var allSolutions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var isUserType = function isUserType(solution) {
    return Array.isArray(solution === null || solution === void 0 ? void 0 : solution.additionalInfos) && (solution === null || solution === void 0 ? void 0 : solution.additionalInfos.some(function (item) {
      return item.value === "User";
    }));
  };

  if (isUserType(targetSolution)) {
    return true;
  } // The targetSolution may miss some data like additionalInfos, get the targetSolution from allSolutions for the entire data.


  var target = allSolutions.find(function (solutionItem) {
    return solutionItem.id === targetSolution.id;
  });
  return isUserType(target);
};

var AssignSolutionRole = function AssignSolutionRole(props) {
  var prefix = props.prefix,
      translate = props.translate,
      solutionRoles = props.solutionRoles,
      _props$disableInitial = props.disableInitialSolutionSelect,
      disableInitialSolutionSelect = _props$disableInitial === void 0 ? false : _props$disableInitial,
      _props$isSelectDefaul = props.isSelectDefaultRole,
      isSelectDefaultRole = _props$isSelectDefaul === void 0 ? true : _props$isSelectDefaul,
      _props$isLabelHidden = props.isLabelHidden,
      isLabelHidden = _props$isLabelHidden === void 0 ? false : _props$isLabelHidden,
      _props$showValidation = props.showValidation,
      showValidation = _props$showValidation === void 0 ? false : _props$showValidation,
      onSolutionRoleChange = props.onSolutionRoleChange,
      resetSolutionList = props.resetSolutionList;

  var _useSolutions = useSolutions(),
      solutionList = _useSolutions.formattedSolutions,
      keySolutions = _useSolutions.keySolutions,
      solutionListLoading = _useSolutions.solutionListLoading,
      filterDisableSolution = _useSolutions.filterDisableSolution;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      solutionValid = _useState2[0],
      setSolutionValid = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showSubscriptionLabel = _useState4[0],
      setShowSubscriptionLabel = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      solutionRolesList = _useState6[0],
      setSolutionRolesList = _useState6[1];

  var labelW = showSubscriptionLabel ? "4" : "6"; // Put the filterDisableSolution outside of the next useEffect to avoid the infinite loop.

  useEffect(function () {
    filterDisableSolution(solutionRolesList);
  }, [filterDisableSolution, solutionRolesList]);
  useEffect(function () {
    checkIsShowSubscriptionLabel();
    setSolutionValid(handleSolutionValid());
    onSolutionRoleChange && onSolutionRoleChange(_toConsumableArray(solutionRolesList), handleSolutionValid());

    function checkIsShowSubscriptionLabel() {
      var filteredHasUserTypeSolutions = solutionRolesList.filter(function (solution) {
        return checkHasUserTypeSubscription(solution, solutionList);
      });

      if (filteredHasUserTypeSolutions.length) {
        setShowSubscriptionLabel(true);
      } else {
        setShowSubscriptionLabel(false);
      }
    }

    function handleSolutionValid() {
      var valid = true;
      solutionRolesList.forEach(function (i) {
        if (!i.id || i.roles && !i.roles.length || checkHasUserTypeSubscription(i, solutionList) && !i.subscription) {
          valid = false;
        }
      });
      return valid;
    }
  }, [onSolutionRoleChange, solutionList, solutionRolesList]);
  useEffect(function () {
    var initialSolutionRoleList = solutionRoles && solutionRoles.map(function (i, index) {
      return _objectSpread(_objectSpread({}, i), {}, {
        _id: index
      });
    });
    setSolutionRolesList(initialSolutionRoleList);
  }, [resetSolutionList, solutionRoles]);

  var onSelectChange = function onSelectChange(item, name, currentSolution) {
    switch (name) {
      case "solution":
        {
          var solution = cloneDeep(item);
          solution.roles = solution.roles && isSelectDefaultRole === true ? [solution.roles[0]] : [];
          solution.subscription = null;
          setSolutionRolesList(solutionRolesList.map(function (i) {
            return i._id === (currentSolution && currentSolution._id) ? _objectSpread(_objectSpread({}, i), solution) : i;
          }));
          break;
        }

      case "role":
        {
          setSolutionRolesList(solutionRolesList.map(function (i) {
            return i._id === (currentSolution && currentSolution._id) ? _objectSpread(_objectSpread({}, i), {
              roles: [item],
              subscription: null
            }) : i;
          }));
          break;
        }

      case "subscription":
        {
          var subscription = cloneDeep(item);
          setSolutionRolesList(solutionRolesList.map(function (i) {
            return i._id === (currentSolution && currentSolution._id) ? _objectSpread(_objectSpread({}, i), {
              subscription: subscription
            }) : i;
          }));
          break;
        }

      default:
        null;
    }
  };

  var deleteSolution = function deleteSolution(e, item) {
    var filteredFormSolutions = solutionRolesList.filter(function (i) {
      return i._id !== item._id;
    });
    filteredFormSolutions.forEach(function (n, index) {
      n._id = index;
    });
    setSolutionRolesList(filteredFormSolutions);
  };

  var handlerAddSolutionRoleBtn = function handlerAddSolutionRoleBtn() {
    setSolutionValid(false);
    setSolutionRolesList([].concat(_toConsumableArray(solutionRolesList), [{
      _id: solutionRolesList.length,
      roles: null,
      subscription: null
    }]));
  };

  var getSubscriptionOptions = function getSubscriptionOptions(solution) {
    var _solution$subscriptio, _solution$roles, _solution$roles$, _keySolutions$solutio, _keySolutions$solutio2, _keySolutions$solutio3, _currentRoleUserTypeS;

    var selectedSubscriptionId = (_solution$subscriptio = solution.subscription) === null || _solution$subscriptio === void 0 ? void 0 : _solution$subscriptio.objectID;

    if (!((_solution$roles = solution.roles) !== null && _solution$roles !== void 0 && (_solution$roles$ = _solution$roles[0]) !== null && _solution$roles$ !== void 0 && _solution$roles$.id)) {
      return {
        options: [],
        selectedSubscriptionId: selectedSubscriptionId
      };
    }

    var solutionId = solution.id;
    var selectedRoleId = solution.roles[0].id;
    var currentRoleUserTypeSubscriptions = (_keySolutions$solutio = keySolutions[solutionId]) === null || _keySolutions$solutio === void 0 ? void 0 : (_keySolutions$solutio2 = _keySolutions$solutio['keyRoles']) === null || _keySolutions$solutio2 === void 0 ? void 0 : (_keySolutions$solutio3 = _keySolutions$solutio2[selectedRoleId]) === null || _keySolutions$solutio3 === void 0 ? void 0 : _keySolutions$solutio3.userSubscriptions;
    var allUserTypeSubscription = getKeyUserTypeSubscriptions();
    var options = (_currentRoleUserTypeS = currentRoleUserTypeSubscriptions === null || currentRoleUserTypeSubscriptions === void 0 ? void 0 : currentRoleUserTypeSubscriptions.filter(function (subscription) {
      //Always keep the selected subscription option, even it has been used in the user edit modal.
      if (selectedSubscriptionId && selectedSubscriptionId === subscription.objectID) {
        return true;
      } // Filter assigned and selected user type subscriptions


      if (subscription.licensedObjectID) {
        return false;
      }

      if (allUserTypeSubscription && allUserTypeSubscription[subscription.objectID].selected) {
        return false;
      }

      return true;
    })) !== null && _currentRoleUserTypeS !== void 0 ? _currentRoleUserTypeS : [];
    return {
      options: options,
      selectedSubscriptionId: selectedSubscriptionId
    };
  };

  var solutionDom = solutionRolesList.length ? /*#__PURE__*/React.createElement(React.Fragment, null, isLabelHidden === false && /*#__PURE__*/React.createElement(Row, {
    className: "".concat(prefix, "-solutions-md-title")
  }, /*#__PURE__*/React.createElement(Col, {
    sm: labelW
  }, /*#__PURE__*/React.createElement(Label, {
    for: "solution"
  }, translate('SFxAccountSettingsUserSolutionLabel')), !solutionValid && /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-require")
  }, "*")), /*#__PURE__*/React.createElement(Col, {
    sm: labelW
  }, /*#__PURE__*/React.createElement(Label, {
    for: "solution"
  }, translate('SFxAccountSettingsUserSolutionRoleLabel')), !solutionValid && /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-require")
  }, "*")), showSubscriptionLabel && /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Label, {
    for: "solution"
  }, translate('SFxAccountSettingsUserSubscriptionLabel')), !solutionValid && /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-require")
  }, "*"))), solutionRolesList.map(function (solution) {
    var _solutionOptions$find, _keySolutions$solutio4, _keySolutions$solutio5, _roleOptions$find, _ref;

    var isUserTypeSolution = checkHasUserTypeSubscription(solution, solutionList);
    var labelWidth = isLabelHidden === true ? isUserTypeSolution ? 4 : 6 : labelW; // Exclude the other selected solutions.

    var solutionOptions = solutionList.filter(function (i) {
      return i.id === solution.id || !i.isDisabled;
    });
    var selectedSolution = (_solutionOptions$find = solutionOptions.find(function (option) {
      return option.id === solution.id;
    })) !== null && _solutionOptions$find !== void 0 ? _solutionOptions$find : null;
    var roleOptions = (_keySolutions$solutio4 = (_keySolutions$solutio5 = keySolutions[solution.id]) === null || _keySolutions$solutio5 === void 0 ? void 0 : _keySolutions$solutio5.roles) !== null && _keySolutions$solutio4 !== void 0 ? _keySolutions$solutio4 : [];
    var selectedRole = (_roleOptions$find = roleOptions.find(function (option) {
      var _solution$roles2, _solution$roles2$;

      return option.id === ((_solution$roles2 = solution.roles) === null || _solution$roles2 === void 0 ? void 0 : (_solution$roles2$ = _solution$roles2[0]) === null || _solution$roles2$ === void 0 ? void 0 : _solution$roles2$.id);
    })) !== null && _roleOptions$find !== void 0 ? _roleOptions$find : null;

    var _getSubscriptionOptio = getSubscriptionOptions(solution),
        subscriptionOptions = _getSubscriptionOptio.options,
        selectedSubscriptionId = _getSubscriptionOptio.selectedSubscriptionId;

    var selectedSubscription = (_ref = selectedSubscriptionId && subscriptionOptions.find(function (option) {
      return option.objectID === selectedSubscriptionId;
    })) !== null && _ref !== void 0 ? _ref : null;
    return /*#__PURE__*/React.createElement("div", {
      key: solution._id,
      className: cx("".concat(prefix, "-solution-select-wrap"), {
        'label-hidden': isLabelHidden
      })
    }, /*#__PURE__*/React.createElement(Row, {
      className: "solution-select-item-wrap"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: labelWidth
    }, /*#__PURE__*/React.createElement(FormGroup, {
      className: cx({
        'show-validation': showValidation && selectedSolution === null
      }),
      style: {
        cursor: disableInitialSolutionSelect === true && solution.isInitialSolution === true ? 'not-allowed' : 'initial'
      }
    }, isLabelHidden === false && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-solutions-xs-title")
    }, /*#__PURE__*/React.createElement(Label, {
      for: "solution"
    }, translate('SFxAccountSettingsUserSolutionLabel')), !solutionValid && !solution.name && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix, "-require")
    }, "*")), /*#__PURE__*/React.createElement(Select, {
      placeholder: isLabelHidden === true ? translate('SFxAccountSettingsUserSolutionLabel') : undefined,
      isDisabled: disableInitialSolutionSelect === true && solution.isInitialSolution === true,
      renderOption: function renderOption(i) {
        return {
          label: i.fullName || i.name,
          value: i.id
        };
      },
      value: selectedSolution,
      options: solutionOptions,
      onChange: function onChange(item) {
        onSelectChange(item, "solution", solution);
      },
      isLoading: solutionListLoading
    }))), /*#__PURE__*/React.createElement(Col, {
      sm: labelWidth
    }, /*#__PURE__*/React.createElement(FormGroup, {
      className: cx({
        'show-validation': showValidation && selectedRole === null
      })
    }, isLabelHidden === false && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-solutions-xs-title")
    }, /*#__PURE__*/React.createElement(Label, {
      for: "solution"
    }, translate('SFxAccountSettingsUserSolutionRoleLabel')), !solutionValid && !solution.roles && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix, "-require")
    }, "*")), /*#__PURE__*/React.createElement(Select, {
      placeholder: isLabelHidden === true ? translate('SFxAccountSettingsUserSolutionRoleLabel') : undefined,
      isMulti: false,
      renderOption: function renderOption(i) {
        return {
          label: i ? i.displayName : "",
          value: i ? i.id : ""
        };
      },
      value: selectedRole,
      options: roleOptions,
      onChange: function onChange(item) {
        return onSelectChange(item, "role", solution);
      }
    }))), isUserTypeSolution && /*#__PURE__*/React.createElement(Col, {
      sm: "4"
    }, /*#__PURE__*/React.createElement(FormGroup, {
      className: cx({
        'show-validation': showValidation && selectedSubscription === null
      })
    }, isLabelHidden === false && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-solutions-xs-title")
    }, /*#__PURE__*/React.createElement(Label, {
      for: "solution"
    }, translate('SFxAccountSettingsUserSubscriptionLabel')), !solutionValid && !solution.subscription && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix, "-require")
    }, "*")), /*#__PURE__*/React.createElement(Select, {
      placeholder: isLabelHidden === true ? translate('SFxAccountSettingsUserSubscriptionLabel') : undefined,
      renderOption: function renderOption(i) {
        return {
          label: "".concat(i.objectID, " ").concat(i.licenseTier.toUpperCase(), " ").concat(i.expiryDate.split("T")[0]),
          value: i.objectID
        };
      },
      value: selectedSubscription,
      components: {
        Option: SubscriptionOption,
        ValueContainer: SubscriptionValue
      },
      options: subscriptionOptions,
      onChange: function onChange(item) {
        return onSelectChange(item, "subscription", solution);
      }
    })))), /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix, "-solution-select-wrap-delete-item"),
      onClick: function onClick(e) {
        return deleteSolution(e, solution);
      }
    }, /*#__PURE__*/React.createElement(IconMinusCircleOutline, {
      size: "20"
    })));
  })) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, solutionDom, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "8",
    className: "".concat(prefix, "-icon-wrap icon-extend")
  }, /*#__PURE__*/React.createElement("span", {
    onClick: handlerAddSolutionRoleBtn
  }, /*#__PURE__*/React.createElement(IconPlusCircleOutline, {
    size: "18"
  }), "\xA0", translate('SFxAccountSettingsAssignSolutionButtonText')))));
};

export default AssignSolutionRole;